import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Modal, Spin, Tag } from 'antd';

import { getConstituent, setMfaOwner, getCurrentConstituent, getConstituentNudgeNotifications } from '../../../actions';

import { ReactRouterTabs } from '../../elements/ReactRouterTabs';

import { ConstituentDetailsForm } from './ConstituentDetailsForm';
import { AccreditationsList } from './Accreditations';
import { ConstituentPermissions } from './Permissions';
import { checkFeature, stripHints } from '../../../utils';
import { TotpLanding } from './TotpLanding';
import { hasPermission } from '../../../utils';
import { Permissions } from '../../../roles.config';
import { withCurrentUser } from '../../../whoami';

@connect(
  (state, ownProps) => {
    const path = (ownProps && ownProps.location && ownProps.location.pathname) || '';
    const isProfile = path.startsWith('/profile');

    const constituent = isProfile
      ? state.doc.getIn(['http', 'getCurrentConstituent', 'data'], null)
      : state.doc.getIn(['constituentsMr', 'byIdFull', ownProps.constituentId], null);

    return {
      isProfile,
      organizationIsActive: state.doc.getIn(['authMr', 'constituent', 'organization', 'isActive'], false),
      emailVerified: state.doc.getIn(['authMr', 'emailVerified'], false),
      constituent,
      getConstituentInProgress: state.doc.getIn(['http', 'getConstituent', 'inProgress']),
      getConstituentFailed: state.doc.getIn(['http', 'getConstituent', 'failed']),
      currentUserMfaStatus: state.doc.getIn(['auth', 'totpEnabled'], false),
      userRole: state.doc.getIn(['http', 'UserRole', 'data'], null),
      organizationId: state.doc.getIn(['authMr', 'constituent', 'organization', 'id'], null),
      nudgeNotifications: state.doc.getIn(['http', 'getConstituentNudgeNotifications', 'data'], null),
      nudgeNotificationsLoading: state.doc.getIn(['http', 'getConstituentNudgeNotifications', 'inProgress'], false),
    };
  },
  { getConstituent, setMfaOwner, getCurrentConstituent, getConstituentNudgeNotifications }
)
@withCurrentUser
export class ConstituentPopup extends PureComponent {
  constructor(props) {
    super(props);
    this.footerRef = React.createRef();
  }

  state = {
    claims: [],
    enableMfa: false,
    userId: null,
    requiredChecks: [],
    loadingRequiredChecks: false,
  }

  setConstituentId = async id => {
    const { isProfile, getCurrentConstituent, getConstituent, setMfaOwner, getConstituentNudgeNotifications } = this.props;

    if (!id) return;

    getConstituentNudgeNotifications(id);

    const response = isProfile ? await getCurrentConstituent() : await getConstituent(id);
    if (!response.success) return;
    if (!response.data.user || !response.data.user.emailVerified) return;
    this.setState({ userId: response.data.user.id, enableMfa: true });
    setMfaOwner(response.data.user.id);
  }

  componentDidMount() {
    const { isProfile, constituentId, currentUser } = this.props;
    // If profile, try to get currentUser constituent ID
    const currentConstituentId = isProfile
      ? (currentUser && currentUser.constituent && currentUser.constituent.id)
      : constituentId;
    this.setConstituentId(currentConstituentId);
    this.fetchRequiredChecks();
  }

  componentDidUpdate(prevProps) {
    const { isProfile } = this.props;
    if (!isProfile && prevProps.constituentId !== this.props.constituentId) {
      this.setConstituentId(this.props.constituentId);
    }
    if (prevProps.constituent !== this.props.constituent) {
      const { claims } = this.props.constituent.toJS();
      this.setState({ claims });

      const prevPositionNumber = prevProps.constituent && prevProps.constituent.get('positionNumber');
      const currentPositionNumber = this.props.constituent && this.props.constituent.get('positionNumber');
      if (prevPositionNumber !== currentPositionNumber) {
        this.fetchRequiredChecks();
      }
    }
  }

  fetchRequiredChecks = async () => {
    const { constituent, organizationId } = this.props;
    const positionNumber = constituent && constituent.get('positionNumber');

    if (!positionNumber || !organizationId) {
      this.setState({ requiredChecks: [], loadingRequiredChecks: false });
      return;
    }

    this.setState({ loadingRequiredChecks: true });

    try {
      const token = localStorage.docToken;
      const headers = {
        'Accept': 'application/json',
      };

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(
        `/api/role_based_accred?position_id=${encodeURIComponent(positionNumber)}&organization_id=${organizationId}`,
        { headers }
      );

      if (response.ok) {
        const data = await response.json();
        this.setState({
          requiredChecks: data.required_checks || [],
          loadingRequiredChecks: false
        });
      } else {
        this.setState({ requiredChecks: [], loadingRequiredChecks: false });
      }
    } catch (error) {
      console.error('Failed to fetch required checks:', error);
      this.setState({ requiredChecks: [], loadingRequiredChecks: false });
    }
  }

  setTabs = tabs => {
    if (checkFeature('mfa') || this.props.currentUserMfaStatus) return tabs;
    tabs.pop();
    return tabs;
  }

  render() {
    const {
      organizationIsActive,
      emailVerified,
      constituent,
      onSuccess,
      closeModal: closeModalProp,
      isNew,
      constituentId,
      userRole,
    } = this.props;

    const name = constituent ? constituent.get('fullName') : 'Person';

    const displayName = stripHints(name);

    const title = isNew ? 'New Person' : `Editing ${displayName}`;

    const activeAccreditations = this.state.claims ? this.state.claims.filter(claim => claim.active) : 0;

    const accredWarning = this.state.claims ? this.state.claims.find(claim => !claim.nameMatch || !claim.active) : false;

     // Default closeModal if not provided
    const closeModal = closeModalProp || (() => {
      this.props.history.push({
        pathname: '/',
        hash: window.location.hash,
        search: window.location.search,
      });
    });

    const { nudgeNotifications, nudgeNotificationsLoading } = this.props;

    // will be sent through to all route children
    const childProps = {
      constituentId,
      constituent,
      isNew,
      footerRef: this.footerRef,
      onCancel: closeModal,
      userId: this.state.userId,
      requiredChecks: this.state.requiredChecks,
      loadingRequiredChecks: this.state.loadingRequiredChecks,
      nudgeNotifications,
      nudgeNotificationsLoading,
    };

    let disabledReason;
    if (!emailVerified) disabledReason = 'Please verify your email to access this feature';
    if (!organizationIsActive) disabledReason = 'Please activate your organisation to access this feature';

    const tabs = [{
      label: 'Details',
      routePath: '/details',
      enabled: true,
      Component: props => (
        <ConstituentDetailsForm onSuccess={onSuccess} isEditable={hasPermission(userRole, Permissions.PEOPLE_DETAILS_EDIT)} {...props}/>
      ),
    }, {
      label: (<span>
        Accreditations
        &nbsp;
        <Tag style={{ marginRight: 0 }} color={ accredWarning ? 'red' : '#C88242' }>
          { activeAccreditations ? activeAccreditations.length : 0 }
        </Tag>
      </span>),
      enabled: !isNew && organizationIsActive && emailVerified,
      disabledReason,
      routePath: '/accreditations',
      Component: props=>(<AccreditationsList isEditable={hasPermission(userRole, Permissions.PEOPLE_ACCREDITATIONS_ADD)} {...props}/>),
    }, {
      enabled: !isNew && emailVerified,
      disabledReason,
      label: 'Permissions',
      routePath: '/permissions',
      Component: props=>(<ConstituentPermissions  canUpgradeAdmin={hasPermission(userRole, Permissions.PEOPLE_PERMISSIONS_UPGRADE_TO_ADMIN)}
        canDowngradeAdmin={hasPermission(userRole, Permissions.PEOPLE_PERMISSIONS_DOWNGRADE_FROM_ADMIN)} canChangePassword={hasPermission(userRole, Permissions.PEOPLE_PERMISSIONS_CHANGE_PASSWORD)} {...props}/>) ,
    }, {
      enabled: this.state.enableMfa && emailVerified,
      disabledReason,
      label: 'MFA',
      routePath: '/mfa',
      Component: TotpLanding,
    },
    ];

    return (<Modal
      visible={true}
      title={title}
      width={ 900 }
      footer={<div ref={this.footerRef}/>}
      onCancel={ closeModal }
            >
      <Spin spinning={!isNew && !constituent}>
        <ReactRouterTabs tabs={this.setTabs(tabs)} childProps={childProps}/>
      </Spin>
    </Modal>);
  }
}

@withRouter
class ConstituentPopupRoute extends PureComponent {
  closeModal = () => {
    this.props.history.push({
      pathname: '/constituents',
      hash: this.props.location.hash,
      search: this.props.location.search,
    });
  }

  onSuccess = data => {
    if (this.props.match.params.id === 'new') {
      this.props.history.push({
        pathname: `/constituents/${data.id}/accreditations`,
        hash: this.props.location.hash,
        search: this.props.location.search,
      });
    } else {
      this.closeModal();
    }
  }

  render() {
    const {
      match: {
        params: {
          id,
        },
      },
      location: {
        pathname,
      },
    } = this.props;

    const [constituentId, isNew] = id === 'new' ? [null, true] : [Number(id), false];

    return (<ConstituentPopup
      constituentId={constituentId}
      isNew={isNew}
      _pathname={pathname} // to force render on change
      closeModal={this.closeModal}
      onSuccess={this.onSuccess}
            />);
  }
}

export {
  ConstituentPopupRoute,
};
